import { initialCommonState } from 'redux/initialState';
import { status } from 'constants/general';

import commonActionTypes from './action-types';

const commonReducer = (state = initialCommonState, { type, payload }) => {
  switch (type) {
    case commonActionTypes.SET_CONTEXT:
      return {
        ...state,
        context: payload,
      };

    case commonActionTypes.FETCH_STATIC_DATA:
      return {
        ...state,
        staticData: {
          status: status.FETCHING,
        },
      };

    case commonActionTypes.FETCH_STATIC_DATA_SUCCESS:
      return {
        ...state,
        staticData: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case commonActionTypes.FETCH_STATIC_DATA_FAIL:
      return {
        ...state,
        staticData: {
          status: status.FAIL,
        },
      };

    case commonActionTypes.FETCH_COMPANY_PROFILES_LIST:
      return {
        ...state,
        companyProfilesList: {
          status: status.FETCHING,
        },
      };

    case commonActionTypes.FETCH_COMPANY_PROFILES_LIST_SUCCESS:
      return {
        ...state,
        companyProfilesList: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case commonActionTypes.FETCH_COMPANY_PROFILES_LIST_FAIL:
      return {
        ...state,
        companyProfilesList: {
          status: status.FAIL,
        },
      };

    case commonActionTypes.RESET_COMPANY_PROFILES_LIST:
      return {
        ...state,
        companyProfilesList: {
          status: status.SHOULD_CALL_API,
        },
      };

    case commonActionTypes.SET_SELECTED_COMPANY_PROFILE:
      return {
        ...state,
        selectedCompanyProfile: payload,
      };

    default:
      return state;
  }
};

export default commonReducer;
